
import React, { useContext, useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";

import AdminSidebar from "../components/AdminSidebar";
import AdminTopbar from "../components/AdminTopbar";

import "../styles/Admin.css";
import { AuthContext } from "../util/api";

const AdminLayout = () => {

    const [sidebarOpen, setSidebarOpen] =
        useState(false);

         const { User, token } = useContext(AuthContext);
            const navigate = useNavigate();

         

    useEffect(() => {
        // Fetch user data or perform any necessary side effects

       

        if (token === "" || token === null /* || User == null || User === "" */) {
            // Redirect to login or show an alert
            navigate("/admin/login");

        }
    }, []);


    return (
        <div className="admin-layout">

            {/* =========================================
                SIDEBAR
            ========================================= */}

            <AdminSidebar
                sidebarOpen={sidebarOpen}
                setSidebarOpen={setSidebarOpen}
            />


            {/* =========================================
                MAIN AREA
            ========================================= */}

            <div className="admin-main">

                <AdminTopbar
                    setSidebarOpen={setSidebarOpen}
                />


                <main className="admin-content">

                    <Outlet />

                </main>

            </div>


            {/* =========================================
                MOBILE OVERLAY
            ========================================= */}

            {sidebarOpen && (

                <div
                    className="admin-sidebar-overlay"
                    onClick={() =>
                        setSidebarOpen(false)
                    }
                />

            )}

        </div>
    );
};

export default AdminLayout;

